import { useTranscriptionStreamingStore } from "@/store/transcriptionStreaming.store";
import { TranscriptionList } from "./TranscriptionList";
import { useEffect } from "react";

export const TranscriptionStreamingList = (): JSX.Element => {
  const { transcriptionStreamText, isLoading, resetStreamText } =
    useTranscriptionStreamingStore();

  useEffect(() => {
    resetStreamText();
  }, [resetStreamText]);

  return (
    <TranscriptionList
      loading={isLoading}
      transcriptions={transcriptionStreamText}
    />
  );
};
